import React, { createContext, useContext, useEffect, useState } from 'react';

import { DemoBlurContext } from '../demo-blur';
import { WebSocketContext } from '../websocket-context/websocket-provider';

import { usePortfolioPerformanceCredentials } from './hooks/use-portfolio-performance-credentials';
import { usePortfolioPerformanceReport } from './hooks/use-portfolio-performance-report';
import {
  IPortfolioPerformanceProvider,
  IPortfolioPerformanceParamsProvider,
  IPortfolioPerformanceAccounts,
} from './portfolio-performance.types';

export const PortfolioPerformanceContext = createContext<IPortfolioPerformanceProvider>({} as any);

export const PortfolioPerformanceProvider: React.FC<IPortfolioPerformanceParamsProvider> = ({
  children,
}) => {
  const { isConnected } = useContext(WebSocketContext);
  const [selectedAccounts, setSelectedAccounts] = useState<IPortfolioPerformanceAccounts[]>([]);
  // Shared, persisted demo-mode switch (one toggle across PP / PM / Account
  // Management). Re-exposed on this context so PP consumers are unchanged.
  const { isNamesBlurred, setIsNamesBlurred } = useContext(DemoBlurContext);

  const { credentials, loadingCredentials, errorCredentials, fetchCredentials } =
    usePortfolioPerformanceCredentials();
  const { reportsByAccount, loadingReportsByAccount, errorReportsByAccount, fetchReport } =
    usePortfolioPerformanceReport();

  useEffect(() => {
    if (!isConnected) return;

    fetchCredentials();
  }, [isConnected]);

  return (
    <PortfolioPerformanceContext.Provider
      value={{
        fetchCredentials,
        credentials,
        loadingCredentials,
        errorCredentials,
        fetchReport,
        reportsByAccount,
        loadingReportsByAccount,
        errorReportsByAccount,
        selectedAccounts,
        setSelectedAccounts,
        isNamesBlurred,
        setIsNamesBlurred,
      }}
    >
      {children}
    </PortfolioPerformanceContext.Provider>
  );
};
